<template>
  <div class="col-md-4 dragme" v-if="user.access > 2">
    <div class="portlet light">
      <i class="fa fa-arrows-alt arrow-move" aria-hidden="true"></i>
      <div class="module-name">Activity Feed</div>
      <div class="portlet-title">
        <div class="caption caption-md">
          <i class="icon-bar-chart font-dark hide"></i>
          <span class="caption-subject font-dark bold uppercase">Activity Feed</span>
        </div>
      </div>
      <div class="portlet-body" style="height: 566px; overflow: hidden;" v-bar>
        <div class="mt-actions" v-if="showLoop(data.activity_feed)">
          <div class="mt-action" v-for="activity in data.activity_feed">
            <div class="mt-action-img">
              <i class="icon-puzzle" v-if="activity.template == 'activities_services'"></i>
              <i class="icon-folder" v-if="activity.template == 'assessment_outcomes'"></i>
              <i class="fa fa-pencil-square-o" aria-hidden="true" v-if="activity.template == 'case_note'"></i>
              <i class="icon-bubbles" v-if="activity.template == 'messages_outbound'"></i>
              <i class="icon-bubbles" v-if="activity.template == 'mass_messages'"></i>
              <i class="icon-bubbles" v-if="activity.template == 'messages_inbound'"></i>
              <i class="icon-cloud-upload" v-if="activity.template == 'import'"></i>
              <i class="icon-users" v-if="['referral_enrolled','referral_not_enrolled'].includes(activity.template)"></i>
              <i class="fa fa-file-text-o" v-if="['shared_form_sent','shared_form_submission'].includes(activity.template)"></i>
              <i class="icon-info" v-if="['shared_form_failed'].includes(activity.template)"></i>

            </div>
            <div class="mt-action-body">
              <div class="mt-action-row">
                <div class="mt-action-info">
                  <div class="mt-action-details ">
                    <span class="mt-action-author">
                      <p v-if="activity.template == 'activities_services'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> {{ completedModified(activity)}} Activities and Services <router-link :to="{ name: 'Activities and Services Edit', params: { id: activity.participant.id , dataid: activity.template_id } }" tag="a">{{ activity.title }}</router-link> on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'assessment_outcomes'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> {{ completedModified(activity)}} Assessment and Outcomes <router-link :to="{ name: 'Assessment and Outcomes Edit', params: { id: activity.participant.id , dataid: activity.template_id } }" tag="a">{{ activity.title }}</router-link> on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'case_note'"> Communication Note completed for <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'messages_outbound'"> {{ activity.title }} sent a message to <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'mass_messages'"> {{ activity.title }} sent a message to {{ activity.details.countAll }} participants on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'messages_inbound'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> sent a message on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'import'">{{ activity.title }} on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'referral_enrolled'">Referral completed for <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'referral_not_enrolled'">Referral completed for <router-link :to="{ name: 'Referral Dashboard', params: { id: activity.template_id } }" tag="a">{{ activity.details.participantName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'shared_form_sent'">{{activity.details.userName}} sent <span v-html="activity.title"></span> to <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link>  on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'shared_form_failed'">An exception has occurred for <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                      <p v-if="activity.template == 'shared_form_submission'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> completed <span v-html="activity.title"></span> on {{ activity.created.date | formatDate }}</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <p v-else>No records available.</p>
      </div>
      <div class="btn-arrow-link activity-feed pull-right">
        <a class="" v-if="showLoop(data.activity_feed)" @click.prevent="openModal">
          VIEW ALL <i class="icon-arrow-right black"></i>
        </a>
      </div>
      <div class="clearfix"></div>
    </div>
    <div id="activity_feed_modal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">ACTIVITY FEED</h4>
            <div class="actions pull-right">
              <a class="btn btn-circle btn-icon-only btn-default" @click.prevent="getReport()">
                <i class="icon-cloud-download"></i>
              </a>
            </div>
          </div>
          <div class="modal-body">
            <form>
              <h5 v-if="!activity.loading">Select Date Range</h5>

              <date-picker
                  v-if="!activity.loading"
                  v-model="range"
                  placeholder="Select Date Range"
                  lang="en"
                  range-separator="-"
                  :format="format"
                  :value-type="'YYYY-MM-DD'"
                  :range="true"
                  :confirm="false"
                  prefix-class="xmx"
                  @change="changeDate"
              />

              <div class="portlet-body" style="height: 466px; overflow: hidden;" v-bar>
                <vue-spinner v-if="activity.loading"></vue-spinner>
                <div class="mt-actions" e-else>
                  <div class="mt-action" v-for="activity in activity.data">
                    <div class="mt-action-img">
                      <i class="icon-puzzle" v-if="activity.template == 'activities_services'"></i>
                      <i class="icon-folder" v-if="activity.template == 'assessment_outcomes'"></i>
                      <i class="fa fa-pencil-square-o" aria-hidden="true" v-if="activity.template == 'case_note'"></i>
                      <i class="icon-bubbles" v-if="activity.template == 'messages_outbound'"></i>
                      <i class="icon-bubbles" v-if="activity.template == 'messages_inbound'"></i>
                      <i class="icon-cloud-upload" v-if="activity.template == 'import'"></i>
                      <i class="icon-users" v-if="['referral_enrolled','referral_not_enrolled'].includes(activity.template)"></i>
                      <i class="fa fa-file-text-o" v-if="['shared_form_sent','shared_form_submission'].includes(activity.template)"></i>
                      <i class="icon-info" v-if="['shared_form_failed'].includes(activity.template)"></i>
                    </div>
                    <div class="mt-action-body">
                      <div class="mt-action-row">
                        <div class="mt-action-info">
                          <div class="mt-action-details ">
                            <span class="mt-action-author">
                              <p v-if="activity.template == 'activities_services'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> {{ completedModified(activity)}} Activities and Services <router-link :to="{ name: 'Activities and Services Edit', params: { id: activity.participant.id , dataid: activity.template_id } }" tag="a">{{ activity.title }}</router-link> on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'assessment_outcomes'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> {{ completedModified(activity)}} Assessment and Outcomes <router-link :to="{ name: 'Assessment and Outcomes Edit', params: { id: activity.participant.id , dataid: activity.template_id } }" tag="a">{{ activity.title }}</router-link> on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'case_note'"> Communication note completed for <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'messages_outbound'"> {{ activity.title }} sent a message to <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'messages_inbound'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> sent a message on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'import'">{{ activity.title }} on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'referral_enrolled'">Referral completed for <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'referral_not_enrolled'">Referral completed for <router-link :to="{ name: 'Referral Dashboard', params: { id: activity.template_id } }" tag="a">{{ activity.details.participantName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'shared_form_sent'">{{activity.details.userName}} sent <span v-html="activity.title"></span> to <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link>  on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'shared_form_failed'">An exception has occurred for <router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> on {{ activity.created.date | formatDate }}</p>
                              <p v-if="activity.template == 'shared_form_submission'"><router-link :to="{ name: 'Dashboard Participant', params: { id: activity.participant.id } }" tag="a">{{ activity.participant.fullName }}</router-link> completed <span v-html="activity.title"></span> on {{ activity.created.date | formatDate }}</p>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <pagination
                :page-count="activity.pages"
                :page-range="1"
                :margin-pages="1"
                :click-handler="changePage"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination pagination-sm'">
              </pagination>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Avatar from '@/components/menu/Avatar.vue'
  import Pagination from '@/components/Pagination.vue'
  import Spinner from '@/components/Spinner'
  import {mapGetters, mapActions} from 'vuex'
  import {URL, getUserInfo} from '@/http-common'
  import DatePicker from 'vue2-datepicker';

  export default {
    data() {
      return {
        range: ['',''],
        from: '',
        to: '',
        page: 1,
      }
    },
    components: {
      Avatar,
      Pagination,
      DatePicker,
      'vue-spinner': Spinner
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        data: 'getOrganizationDashboard',
        activity: 'getActivity'
      }),
      format() {
        return getUserInfo('date_format')
      }
    },
    methods: {
      ...mapActions({
        getActivityFeed: 'GET_WIDGET_ACTIVITY_FEED_ACTION',
        getReportAction: 'ACTIVITY_FEED_REPORT_ACTION'
      }),
      renderText(template, name, date) {
        return eval(template);
      },
      openModal() {
        this.range = [];
        $('#activity_feed_modal').modal('show');
        this.getActivityFeed({from: '', to: '', page: 1});
      },
      showLoop(data) {
        if(data != null)
          return (data.length > 0)
      },
      changeDate() {
        this.getActivityFeed({from: this.range[0], to: this.range[1], page: 1});
      },
      changePage(page) {
        this.getActivityFeed({from: this.range[0], to: this.range[1], page: page});
      },
      getReport() {
        this.getReportAction({from: this.range[0], to: this.range[1], timezone: this.user.time_zone});
      },
      getDownloadUrl() {
        return `${URL}/activities/export?from=${this.range[0]}&to=${this.range[1]}&token=${localStorage.getItem('id_token')}`
      },
      completedModified(activity) {
        if(!activity.hasOwnProperty('details')) {
          return 'completed';
        }

        if(activity.details.hasOwnProperty('action')) {
          if(activity.details.action == 'updated') {
            return 'modified';
          }
          if(activity.details.action === 'created') {
            return 'completed';
          }

          return activity.details.action;
        }

        return 'completed';
      }
    }
  }
</script>
<style scoped>
  .portlet.reset {
    padding: 0px;
  }

  .mt-action-author {
    font-weight: 400 !important;
  }

  .mt-action-img {
    width: 45px !important;
  }

  .mt-actions .mt-action .mt-action-body p{
    margin:5px 0;
  }
  .mt-actions .mt-action .mt-action-body {
    padding-right: 10px;
    padding-left:52px;
  }

  .activity-feed {
    padding-top: 10px;
  }

  .mt-actions .mt-action .mt-action-img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .mt-actions .mt-action {
    padding: 11px 0 11px 0;
    position: relative;
  }

  .date-inline {
    display: flex;
    margin-bottom: 20px;
  }

  .date-to {
    padding: 7px 10px;
  }

  .pagination {
    display: flex;
    justify-content: center;
  }
  #activity_feed_modal p {
    margin:0px;
  }

  #activity_feed_modal .modal-header button {
    margin-right: 10px;
  }

  #activity_feed_modal .modal-title {
    display: inline-block;
  }

  #activity_feed_modal .modal-sm {
    width: 400px;
  }

  #activity_feed_modal .modal-dialog {
    position: absolute;
    left: 70px;
  }
  .mt-action-img i {
    font-size:25px;
    margin-top: 10px;
    padding-left: 7px;
  }
  #activity_feed_modal .actions {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// ActivityFeed.vue?315be850